module.exports = __webpack_public_path__ + "img/keno_logo_22.dbf1260f.png";